import { render, staticRenderFns } from "./upgradeLog.vue?vue&type=template&id=a83e38da&"
import script from "./upgradeLog.vue?vue&type=script&lang=js&"
export * from "./upgradeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a83e38da')) {
      api.createRecord('a83e38da', component.options)
    } else {
      api.reload('a83e38da', component.options)
    }
    module.hot.accept("./upgradeLog.vue?vue&type=template&id=a83e38da&", function () {
      api.rerender('a83e38da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edition/upgradeLog.vue"
export default component.exports